import { Api } from "./api"
import { attributes } from "./attributes/sample-atribute"

export class MasterSampleApi extends Api {
  constructor() {
    super('master_samples', attributes)
  }
}
